module.exports = __webpack_public_path__ + "static/device-screens-9becfb83088abed7aad94f0f67eb70e2.png";